export default {
      id: "facebook-usage",
      viewBox: "0 0 10.2 19",
      url: __webpack_public_path__ + "svg/sprite.svg#facebook",
      toString: function () {
        return this.url;
      }
    }